module.exports = __webpack_public_path__ + "static/media/wrinkles_forehead.4d2a2fc6.svg";